import { render, staticRenderFns } from "./IBTable.vue?vue&type=template&id=c50a3072"
import script from "./IBTable.vue?vue&type=script&lang=js"
export * from "./IBTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports